import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "overview"
    }}>{`Overview`}</h1>
    <p>{`UXP scripting allows developers to execute a single file to accomplish tasks in Photoshop. Unlike ExtendScript, these scripts can utilize the `}<a parentName="p" {...{
        "href": "../uxp-api/"
      }}>{`UXP`}</a>{` and `}<a parentName="p" {...{
        "href": "../ps_reference/"
      }}>{`Photoshop`}</a>{` APIs to communicate with Photoshop.`}</p>
    <h2 {...{
      "id": "when-are-scripts-useful"
    }}>{`When are scripts useful?`}</h2>
    <p>{`Scripts are mainly used to perform one-off tasks that end-users would otherwise perform manually. It is especially useful when the task is repetitive in nature, such as adding a watermark to your documents. When a script is invoked by a user, it executes a task and is unloaded by Photoshop once it’s done. If required, a dialog can be used to prompt the user for inputs. Scripts can be executed in a headless manner or with minimal UI, without the need for any manifest setup.`}</p>
    <p>{`The biggest advantage that scripting offers is its simplicity. You can accomplish tasks in Photoshop without requiring as elaborate of a setup as that of a UXP plugin.  Any script code can be reused in a UXP plugin as well.`}</p>
    <h2 {...{
      "id": "how-is-it-different-from-uxp-plugin-development"
    }}>{`How is it different from UXP plugin development?`}</h2>
    <ol>
      <li parentName="ol"><strong parentName="li"><a parentName="strong" {...{
            "href": "../scripting/how-it-works/index.md#execution-context"
          }}>{`Lifetime`}</a>{`:`}</strong>{` A script’s lifetime ends when it finishes executing.`}</li>
      <li parentName="ol"><strong parentName="li"><a parentName="strong" {...{
            "href": "../scripting/how-it-works/index.md#user-interface"
          }}>{`Limited UI`}</a>{`:`}</strong>{` Unlike plugins, scripts cannot have a panel UI. They can only create dialog UIs.`}</li>
      <li parentName="ol"><strong parentName="li">{`No persistent data:`}</strong>{` Scripts also don’t have access to persistent storage like the plugin data folder or `}<inlineCode parentName="li">{`window.localStorage`}</inlineCode>{`. `}</li>
      <li parentName="ol"><strong parentName="li"><a parentName="strong" {...{
            "href": "../scripting/how-it-works/index.md#permitted-uxp-modules"
          }}>{`Limited access to UXP modules`}</a>{`:`}</strong>{` Permissions to access UXP modules are managed by the host application and for now, only a limited number of modules are enabled. `}<em parentName="li">{`We plan on enabling more modules with future versions.`}</em></li>
      <li parentName="ol"><strong parentName="li">{`No identity:`}</strong>{` UXP scripts are not supported in our distribution channels yet. Once shared, any user can use them. Plugins on the other hand are tied to a plugin ID, and procured via the CCD plugin marketplace. `}</li>
    </ol>
    <h2 {...{
      "id": "how-is-this-different-from-extendscript-scripting"
    }}>{`How is this different from ExtendScript scripting?`}</h2>
    <p>{`Legacy extensibility platforms supported scripting in ExtendScript. ExtendScript uses a very old version of JavaScript (ES3), while UXP uses the V8 JavaScript engine which supports ES6.  Developers can write scripts while utilizing the flexibility offered by modern JavaScript. `}</p>
    <p>{`Compared to ExtendScript, UXP scripting makes it much easier for developers to access the Photoshop DOM (thanks to the Photoshop API!). Until all significant features are available via UXP, you can use a feature called `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/photoshop/uxp/2022/ps_reference/media/batchplay/"
      }}><strong parentName="a">{`batchPlay`}</strong></a>{` to talk to Photoshop elements. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      